// extracted by mini-css-extract-plugin
export default {"icon":"breadcrumb_icon__Xo5uJ","folderName":"breadcrumb_folderName__TnP-2","divider":"breadcrumb_divider__3Vog+"};